/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_IAppServices_AwardVestingDateDto } from '../models/Wealthlane_AwardService_IAppServices_AwardVestingDateDto';
import type { Wealthlane_AwardService_IAppServices_CalculateAwardAdjustmentWithVestingResultDto } from '../models/Wealthlane_AwardService_IAppServices_CalculateAwardAdjustmentWithVestingResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CalculateAwardAdjustmentService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_IAppServices_CalculateAwardAdjustmentWithVestingResultDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCalculateAwardAdjustmentCalculateTargetCancelledUnit(
requestBody?: Wealthlane_AwardService_IAppServices_AwardVestingDateDto,
): CancelablePromise<Array<Wealthlane_AwardService_IAppServices_CalculateAwardAdjustmentWithVestingResultDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/calculate-award-adjustment/calculate-target-cancelled-unit',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
